// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminGlobalLayout_wrapper__fctIP"};